import type {GoalState,ThreadRecord} from '@reados/contracts';
import type {GoalSetInput} from '@reados/goal-ui';
import {api} from './api';

/** Admit the composer's text as a native goal, without creating a duplicate turn. */
export async function setComposerGoal(threadId:string,input:GoalSetInput):Promise<GoalState>{
 const result=await api.rpc<{goal:GoalState}>(threadId,'thread/goal/set',{...input,status:'active'});
 if(!result.goal||typeof result.goal.objective!=='string'||typeof result.goal.status!=='string')throw new Error('服务端尚未确认目标，请重试。');
 return result.goal;
}

/** Keep the created identity when goal admission fails so retry uses one thread. */
export async function setPendingComposerGoal(created:{current:string|null},input:GoalSetInput,createThread:()=>Promise<ThreadRecord>,selectThread:(id:string)=>Promise<void>):Promise<void>{
 if(!created.current)created.current=(await createThread()).id;
 await setComposerGoal(created.current,input);
 await selectThread(created.current);
}
